// extracted by mini-css-extract-plugin
module.exports = {"resource":"livestream-event-CourseSessionResource__resource--JkXU2"};